import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import {baseconfig,rsaBasicModuleConfig} from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'
export const policycompilationModule = {

    // 政策措施列表
    async policymeasureinfolist(page,pagesize,policy_class_id,policy_type_id,pm_p1,pm_p4,start_create_time,end_create_time) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken + '~A6S5D4d',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'policymeasureinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&policy_class_id=' + policy_class_id + '&policy_type_id=' + policy_type_id  + '&pm_p1=' + pm_p1  + '&pm_p4=' + pm_p4 + '&start_create_time=' + start_create_time + '&end_create_time=' + end_create_time, 'get', null, null)
   },
   //政策措施详情
   async policymeasureinfo(policy_measure_id,mark) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id)+ '~JA65S4DI9',rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'policymeasureinfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&policy_measure_id=' + policy_measure_id+ '&mark=' + mark, 'get', null, null);
    },
    //添加政策措施
    async addpolicymeasureinfo(policy_class_id,policy_type_id,pm_p1,pm_p3,pm_p4,pm_p5,pm_p6,pm_p11) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_class_id: policy_class_id,
            policy_type_id:policy_type_id,
            pm_p1:pm_p1,
            pm_p3:pm_p3,
            pm_p4:pm_p4,
            pm_p5:pm_p5,
            pm_p6:pm_p6,
            pm_p11:pm_p11,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_class_id) + String(policy_type_id)+ String(pm_p4) + String(pm_p5) +'!ASD65465',rsaBasicModuleConfig.clientPrivateKey)

        }
        return await httpRequest(baseUrl.basic + 'addpolicymeasureinfo', 'put', qs.stringify(paras), null)
    },  
     // 编辑政策措施 --HYT
     async editpolicymeasureinfo(policy_measure_id,policy_class_id,policy_type_id,pm_p1,pm_p3,pm_p5,pm_p6,pm_p11,original_value_json) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            policy_class_id: policy_class_id,
            policy_type_id:policy_type_id,
            pm_p1:pm_p1,
            pm_p3:pm_p3,
            pm_p5:pm_p5,
            pm_p6:pm_p6,
            pm_p11:pm_p11,
            original_value_json: original_value_json,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id)  + String(policy_class_id) + String(policy_type_id) + String(pm_p5) + '~ASDQW5E4324',rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'editpolicymeasureinfo', 'post', qs.stringify(paras), null)
    },
     //禁用启用政策措施 --HYT
     async logoutpolicymeasureinfo(policy_measure_id,pm_p7,pm_p8,pm_p9,pm_p10,people_logout_reason_id) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            pm_p7: pm_p7,
            pm_p8: pm_p8,
            pm_p9: pm_p9,
            pm_p10: pm_p10,
            people_logout_reason_id: people_logout_reason_id,
           
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(pm_p7) + '~zxD1',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'logoutpolicymeasureinfo', 'post', qs.stringify(paras), null)
    },
    //删除政策措施--HYT
    async delpolicymeasureinfo(policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + 'djsej@2dfs',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'delpolicymeasureinfo', 'post', qs.stringify(paras), null)
    },
}
//资金比例
export const fundsalLocationModule = {
    // /fundspolicymeasureinfolist 资金比例--》政策措施列表 HYT
    async fundspolicymeasureinfolist(page,pagesize,policy_class_id,policy_type_id,pm_p1,pm_p4,start_create_time,end_create_time) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~A6S5D4d',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'fundspolicymeasureinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&policy_class_id=' + policy_class_id + '&policy_type_id=' + policy_type_id  + '&pm_p1=' + pm_p1  + '&pm_p4=' + pm_p4 + '&start_create_time=' + start_create_time + '&end_create_time=' + end_create_time, 'get', null, null)
    },
     // 资金比例列表--CGX
     async fundsallocationllist(policy_measure_id,page,page_size) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + 'DFSJKFK',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'fundsallocationllist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&policy_measure_id=' + policy_measure_id, 'get', null, null)
    },
    //资金比例详情--CGX
    async fundsallocationinfo(funds_allocation_id) {
         const adminToken = store.getters.adminID
         var paras = {
             timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
             _sign: rsa.signString(baseconfig.v + adminToken + String(funds_allocation_id)+ 'sfnjokl',rsaBasicModuleConfig.clientPrivateKey)
         }
         return await httpRequest(baseUrl.basic + 'fundsallocationinfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&funds_allocation_id=' + funds_allocation_id, 'get', null, null);
     },
     //添加资金比例
     async addfundsallocationinfo(policy_measure_id,region_level,p1,p2,p3,p4,p5,p6,p7,p8,p9) {
         const adminToken = store.getters.adminID
         var paras = {
            policy_measure_id: policy_measure_id,
            region_level:region_level,
            p1:p1,
            p2:p2,
            p3:p3,
            p4:p4,
            p5:p5,
            p6:p6,
            p7:p7,
            p8:p8,
            p9:p9,
             timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
             _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level)+'dnmskfe',rsaBasicModuleConfig.clientPrivateKey)
 
         }
         return await httpRequest(baseUrl.basic + 'addfundsallocationinfo', 'put', qs.stringify(paras), null)
     },  
      // 修改资金比例--CGX
      async editfundsallocationinfo(funds_allocation_id,fa_p3,fa_p4,fa_p5,fa_p6,fa_p7,fa_p8,fa_p9,original_value_json) {
         const adminToken = store.getters.adminID
         var paras = {
            funds_allocation_id: funds_allocation_id,
            fa_p3: fa_p3,
            fa_p4:fa_p4,
            fa_p5:fa_p5,
            fa_p6:fa_p6,
            fa_p7:fa_p7,
            fa_p8:fa_p8,
            fa_p9:fa_p9,
            original_value_json: original_value_json,
             timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
             _sign: rsa.signString(baseconfig.v + adminToken + String(funds_allocation_id) + 'DFNSAJL',rsaBasicModuleConfig.clientPrivateKey)
         }
         return await httpRequest(baseUrl.basic + 'editfundsallocationinfo', 'post', qs.stringify(paras), null)
     },
      //注销资金比例--CGX
      async editfundsallocationlogout(funds_allocation_id,logout_reason_id,logout_reason_time) {
         const adminToken = store.getters.adminID
         var paras = {
            funds_allocation_id: funds_allocation_id,
            logout_reason_id: logout_reason_id,
            logout_reason_time: logout_reason_time,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(funds_allocation_id)+ 'djsej@2dfs',rsaBasicModuleConfig.clientPrivateKey),
         }
         console.log(baseconfig.v + adminToken + String(funds_allocation_id) + String(logout_reason_id) + 'djsej@2dfs')
         return await httpRequest(baseUrl.basic + 'editfundsallocationlogout', 'post', qs.stringify(paras), null)
     },
     //删除资金比例--CGX
     async delfundsallocationinfo(funds_allocation_id) {
         const adminToken = store.getters.adminID
         var paras = {
            funds_allocation_id: funds_allocation_id,
             timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
             _sign: rsa.signString(baseconfig.v + adminToken + String(funds_allocation_id) + 'djsej@2dfs',rsaBasicModuleConfig.clientPrivateKey),
         }
         return await httpRequest(baseUrl.basic + 'delfundsallocationinfo', 'post', qs.stringify(paras), null)
     },
}
//资金量化金额
export const fundsStandardModule = {
    // 资金量化金额列表 HYT
    async fundsstandardinfolist(policy_measure_id) {
       const adminToken = store.getters.adminID
       var paras = {
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken  + '~LASD12d',rsaBasicModuleConfig.clientPrivateKey),
       }
       return await httpRequest(baseUrl.basic + 'fundsstandardinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&policy_measure_id=' + policy_measure_id, 'get', null, null)
   },
   //资金量化金额详情 HYT
   async fundsstandardinfo(funds_standard_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(funds_standard_id)+ '~Jasd1I9',rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'fundsstandardinfo?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&funds_standard_id=' + funds_standard_id, 'get', null, null);
    },
    //添加资金量化金额 --HYT
    async addfundsstandardinfo(policy_measure_id,quantitative_standard,quantitative_description) {
        const adminToken = store.getters.adminID
        var paras = {
           policy_measure_id: policy_measure_id,
           quantitative_standard:quantitative_standard,
           quantitative_description:quantitative_description,
           timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
           _sign: rsa.signString(baseconfig.v + adminToken +'!123axdc',rsaBasicModuleConfig.clientPrivateKey)

        }
        return await httpRequest(baseUrl.basic + 'addfundsstandardinfo', 'put', qs.stringify(paras), null)
    },  
     // 编辑资金量化金额 --HYT
     async editfundsstandardinfo(funds_standard_id,policy_measure_id,quantitative_standard,quantitative_description,original_value_json) {
        const adminToken = store.getters.adminID
        var paras = {
            funds_standard_id: funds_standard_id,
            policy_measure_id: policy_measure_id,
            quantitative_standard:quantitative_standard,
            quantitative_description:quantitative_description,
            original_value_json: original_value_json,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(funds_standard_id) + String(policy_measure_id) + String(quantitative_standard) + '~Aasd15324',rsaBasicModuleConfig.clientPrivateKey)
        }
        return await httpRequest(baseUrl.basic + 'editfundsstandardinfo', 'post', qs.stringify(paras), null)
    },
     //禁用启用资金量化金额 --HYT
     async logoutfundsstandardinfo(funds_standard_id,logout_status,logout_time) {
        const adminToken = store.getters.adminID
        var paras = {
            funds_standard_id: funds_standard_id,
            logout_status: logout_status,
            logout_time: logout_time,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(funds_standard_id) + String(logout_status) + '~zxvaZFD1',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'logoutfundsstandardinfo', 'post', qs.stringify(paras), null)
    },
    //删除资金量化金额 -- HYT
    async delfundsstandardinfo(funds_standard_id) {
        const adminToken = store.getters.adminID
        var paras = {
            funds_standard_id: funds_standard_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(funds_standard_id) + 'djsej@2dfs',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'delfundsstandardinfo', 'post', qs.stringify(paras), null)
    },
}